import Stack from '@mui/material/Stack';
import { Control, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { FormSectionHeader } from '../../../../../shared/form-section-header';
import { GroupTemplateFormData } from '../group-template-form-data';
import StepFour from '../step-four';

interface SecurityStepProps {
  control: Control<GroupTemplateFormData>;
  watch: UseFormWatch<GroupTemplateFormData>;
  setValue: UseFormSetValue<GroupTemplateFormData>;
}

export default function SecurityStep({
  control,
  watch,
  setValue,
}: SecurityStepProps) {
  return (
    <Stack gap={3}>
      <FormSectionHeader>Security Settings</FormSectionHeader>
      <StepFour control={control} watch={watch} setValue={setValue} />
    </Stack>
  );
}
